export type AbandonChatRequest = {
  conversationId: string;
};

export async function abandonChat(
  supportFetch: typeof fetch,
  {conversationId}: AbandonChatRequest,
): Promise<void> {
  const response = await supportFetch('/api/abandon-chat', {
    method: 'POST',
    body: JSON.stringify({conversationId}),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('failed to handle abandoned chat');
  }
}
